import { ProgressBar } from '@/components/charts';
import { DataRow, InstallmentBadge, type Column } from '@/components/data';
import { formatBRL } from '@/components/foundations/Amount';

export type InstallmentPurchase = {
  name: string;
  /** Parcela atual. */
  n: number;
  /** Total de parcelas. */
  of: number;
  /** Valor de cada parcela, em reais. */
  value: number;
  total: number;
  /** Mês da última parcela (ex.: "jun/27"). */
  ends: string;
};

/** O que ainda falta pagar de uma compra parcelada. */
export const remaining = (p: InstallmentPurchase) => p.value * (p.of - p.n);

/** Colunas da tabela de compras parceladas (compartilhadas entre `InstallmentRow` e o cabeçalho). */
export const INSTALLMENT_COLUMNS: Column<InstallmentPurchase>[] = [
  { key: 'name', header: 'Compra', cellClassName: 'wrap', cellStyle: { fontWeight: 600 }, render: (p) => p.name },
  { key: 'n', header: 'Parcela', render: (p) => <InstallmentBadge n={p.n} of={p.of} /> },
  { key: 'prog', header: 'Progresso', hideOnMobile: true, width: 200, render: (p) => <ProgressBar flush value={p.n / p.of} label={`${p.n} de ${p.of} parcelas pagas`} /> },
  { key: 'value', header: 'Valor da parcela', align: 'right', render: (p) => formatBRL(p.value) },
  { key: 'total', header: 'Total', align: 'right', hideOnMobile: true, render: (p) => formatBRL(p.total) },
  { key: 'rest', header: 'Falta pagar', align: 'right', hideOnMobile: true, cellStyle: { color: 'var(--gold-d)', fontWeight: 600 }, render: (p) => formatBRL(remaining(p)) },
  { key: 'ends', header: 'Termina', hideOnMobile: true, render: (p) => p.ends },
];

/** Linha da tabela de parcelas: compra, n/de, progresso, valor, total, falta e término. */
export function InstallmentRow({ purchase }: { purchase: InstallmentPurchase }) {
  return <DataRow columns={INSTALLMENT_COLUMNS} row={purchase} />;
}
